import { departmentMembersFromEntity, departmentUsernameFromValue, } from '@/shared/model/department.model';
export function mapCrmDepartmentReference(department) {
    return {
        id: String(department.id ?? ''),
        name: department.name ?? department.departmentName ?? '',
        description: department.description,
        supervisorUsername: departmentUsernameFromValue(department.supervisorUsername ?? department.supervisor) || undefined,
        departmentHeadUsername: departmentUsernameFromValue(department.departmentHeadUsername ?? department.departmentHead) ||
            undefined,
        memberUsernames: departmentMembersFromEntity(department).map((member) => member.username),
    };
}
export function buildSupervisorOptions(departments, users = []) {
    const nameByUsername = new Map(users.flatMap((user) => {
        const username = user.username ?? user.id;
        if (!username)
            return [];
        return [[username, user.name ?? username]];
    }));
    const seen = new Set();
    const options = [];
    for (const department of departments) {
        const supervisorUsername = departmentUsernameFromValue(department.supervisorUsername ?? department.supervisor);
        if (!supervisorUsername || seen.has(supervisorUsername))
            continue;
        seen.add(supervisorUsername);
        const displayName = nameByUsername.get(supervisorUsername) ?? supervisorUsername;
        options.push({
            value: supervisorUsername,
            label: displayName === supervisorUsername ? supervisorUsername : `${displayName} (${supervisorUsername})`,
        });
    }
    return options.sort((a, b) => a.label.localeCompare(b.label));
}
export function resolveDepartmentSupervisorUsername(departmentId, departments) {
    if (departmentId == null || departmentId === '')
        return undefined;
    const department = departments.find((item) => String(item.id ?? '') === String(departmentId));
    if (!department)
        return undefined;
    return departmentUsernameFromValue(department.supervisorUsername ?? department.supervisor) || undefined;
}
export function resolveDepartmentHeadUsername(departmentId, departments) {
    if (departmentId == null || departmentId === '')
        return undefined;
    const department = departments.find((item) => String(item.id ?? '') === String(departmentId));
    if (!department)
        return undefined;
    return (departmentUsernameFromValue(department.departmentHeadUsername ?? department.departmentHead) ||
        undefined);
}
export function isUserDepartmentMember(username, department) {
    if (!username)
        return false;
    return (department.memberUsernames ?? []).includes(username);
}
export function resolveUserDepartmentSupervisorUsername(username, departments) {
    if (!username)
        return undefined;
    for (const department of departments) {
        if (!isUserDepartmentMember(username, department))
            continue;
        const supervisorUsername = departmentUsernameFromValue(department.supervisorUsername ?? department.supervisor);
        if (supervisorUsername)
            return supervisorUsername;
    }
    return undefined;
}
export function isUserDepartmentSupervisor(username, departments) {
    if (!username)
        return false;
    return departments.some((department) => {
        const supervisorUsername = departmentUsernameFromValue(department.supervisorUsername ?? department.supervisor);
        return supervisorUsername === username;
    });
}
